import SimpleButton from "lib/components/common/simple-button";
import SimpleCard from "lib/components/common/simple-card";
import SimpleDataTable from "lib/components/common/simple-data-table";
import SimpleModal from "lib/components/common/simple-modal";
import DashboardLayout from "lib/components/layouts/dashboard";
import RoomBookingSummaryTile from "lib/components/practitioners/room-booking-summary-tile";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { PRACTITIONER_SUBSCRIPTIONS_COLUMNS } from "lib/constants/table-columns";
import { AppContext } from "lib/contexts/app-context";
import { CheckoutContext } from "lib/contexts/practitioner-subscriptions-context";

import usePractitioner from "lib/hooks/usePractitioner";
import usePractitionerSubscriptionContext from "lib/hooks/usePractitionerSubscriptionContext";
import useSubscriptions from "lib/hooks/useSubscription";
import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const breadcrumbItems: BreadcrumbItem[] = [
  {
    label: "Subscriptions",
    path: PAGE_ROUTES.PRACTITIONER.Subscription,
  },
];

interface PractitionerSubscriptionsListPageProps {}

const PractitionerSubscriptionsListPage: FC<
  PractitionerSubscriptionsListPageProps
> = ({}) => {
  const navigateTo = useNavigate();
  const { appState } = useContext(AppContext);
  const { checkoutState } = useContext(CheckoutContext);
  const { getPractitionerSubscriptionsWithPastDates, loading, error } = usePractitioner();
  const {
    getSubscriptionById,
    loading: subscriptionLoading,
    error: subscriptionError,
  } = useSubscriptions();

  const [subscriptions, setSubscriptions] = useState<
    PractitionerSubscriptionDetails[]
  >([]);

  const [selectedSubscription, setSelectedSubscription] =
    useState<PractitionerSubscriptionDetails | null>(null);

  useEffect(() => {
    getPractitionerSubscriptionsWithPastDates(appState?.user_id, setSubscriptions);
  }, []);

  if (subscriptions?.length > -1) {
    console.log("Subscriptions: ", subscriptions);
  }

  const handleAddSubscription = () => {
    navigateTo(PAGE_ROUTES.PRACTITIONER.BuySubscription);
  };

  const handleSubscriptionSelection = (
    row: PractitionerSubscriptionDetails
  ) => {
    const subscription = row as PractitionerSubscriptionDetails;

    if (subscription?.isActive) {
      //getSubscriptionById(subscription.subscriptionId, setSelectedSubscription);
      setSelectedSubscription(subscription);
    } else if (!subscription?.isActive && subscription.isCancelled) {
      setSelectedSubscription(subscription);
    } else {
      navigateTo(PAGE_ROUTES.PRACTITIONER.SubscriptionFailure, {
        state: {
          transactionId: subscription.id,
        },
      });
    }
  };

  return (
    <DashboardLayout breadcrumbItems={breadcrumbItems}>
      <SimpleCard
        title="My Subscriptions"
        isLoading={loading || subscriptionLoading}
        action={
          <SimpleButton
            isLoading={loading}
            onClick={handleAddSubscription}
            disabled={checkoutState?.practitioner?.isDisabled}
          >
            Add Subscription
          </SimpleButton>
        }
        error={error}
      >
        <SimpleDataTable
          columns={PRACTITIONER_SUBSCRIPTIONS_COLUMNS}
          data={subscriptions ?? []}
          onRowClick={handleSubscriptionSelection}
        />
      </SimpleCard>
      <SimpleModal
        open={!!selectedSubscription}
        close={() => setSelectedSubscription(null)}
        title="Booking Details"
        size="sm"
        loading={subscriptionLoading || loading}
      >
        {selectedSubscription &&
        selectedSubscription?.isCancelled &&
        !selectedSubscription?.isActive ? (
          <p>Your Booking has been cancelled. No transaction Needed</p>
        ) : (
          <RoomBookingSummaryTile
            dates={selectedSubscription?.internalDates}
            clinicName={selectedSubscription?.clinicName}
            isShowFromDateToDate
            practitionerName={appState?.name}
            pricePerDay={selectedSubscription?.perDayPrice ?? 0}
            roomNumber={selectedSubscription?.room ?? 0}
            rooms={[]}
          />
        )}
      </SimpleModal>
    </DashboardLayout>
  );
};

export default PractitionerSubscriptionsListPage;
